
import axios from 'axios';

export const BACKEND_URL = window._env_?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// P4: Enhanced auth error handling for single session enforcement
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const detail = error.response?.data?.detail || '';
      const isAdminPath = window.location.pathname.includes('/admin');
      
      // Only auto-logout for these specific session invalidation cases
      const shouldLogout = 
        detail.includes('another device') || 
        detail.includes('invalidated') ||
        detail.includes('Session expired') ||
        detail.includes('Invalid session');
      
      if (shouldLogout) {
        // Show alert to user only for "another device" case
        if (detail.includes('another device')) {
          alert('Your session has been ended because you logged in from another device.');
        }
        
        if (isAdminPath) {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          // Use a flag to prevent redirect loops
          if (!sessionStorage.getItem('redirecting')) {
            sessionStorage.setItem('redirecting', 'true');
            window.location.href = '/';
          }
        }
      }
      // For other 401 errors (e.g., wrong password), don't auto-logout
    } else if (error.response?.status === 403) {
      // Handle forbidden (subscription limits, etc.)
      const detail = error.response?.data?.detail || '';
      if (detail.includes('Session') || detail.includes('session')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

// Clear redirect flag on successful navigation
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    sessionStorage.removeItem('redirecting');
  });
}

export function wsUrl() {
  if (!BACKEND_URL) return '';
  const u = new URL(BACKEND_URL);
  const proto = u.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${u.host}/api/ws`;
}
